<rad-popover 
  [attr.popover-placement]="popoverPlacement"
  [attr.popover-append-to]="popoverAppendTo"
  >
  <rad-icon 
    name="info" 
    size="sm"
    style="cursor: pointer;">
    </rad-icon>
    <rad-popover-custom-content>
        <div
            class="popover-info-icon__content"
            [class.popover-info-icon__content--compact]="compact"
         >
            <!-- Use innerHTML if helpText is provided, otherwise use ng-content -->
            <ng-container *ngIf="helpText; else contentProjection">
              <span [innerHTML]="helpText"></span>
            </ng-container>
            <ng-template #contentProjection>
              <ng-content></ng-content>
            </ng-template>
         </div>
    </rad-popover-custom-content>
</rad-popover>
